import { reduxForm } from 'redux-form/immutable'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import LoginForm from '../LoginForm'
import { postAuthPhone } from 'store/entities/identity/actions'
import { clearLoginError } from 'store/entities/ui/actions'
import { setQueries } from 'store/entities/localSettings/actions'
import { getUILoginPhoneError, getUILoginSubmitting } from 'store/entities/ui/selectors'
import { parsePhoneBeforeSend } from 'helpers/parsePhone'
import { ISO_CODE } from 'app/constants/phoneCountryCodes'

const mapStateToProps = (state, { countriesCodes }) => ({
  loginError: getUILoginPhoneError(state),
  isSubmitting: getUILoginSubmitting(state),
  initialValues: Map({
    phoneISO: countriesCodes.getIn([0, 'country']),
  }),
})

const formProps = {
  form: 'LOGIN_PHONE_FORM',
  onSubmit: (values, dispatch) => {
    const phone = values.get('phone').trim()
    const iso = values.get('phoneISO').trim()
    const code = ISO_CODE[iso]

    if (phone) {
      const tel = parsePhoneBeforeSend(`${code}${phone}`)
      dispatch(postAuthPhone(tel))
      dispatch(setQueries({ phone: tel }))
    }
  },
  onChange: (values, dispatch, props) => {
    if (props.loginError) {
      dispatch(clearLoginError())
    }
  },
  touchOnBlur: false,
}

export default connect(mapStateToProps)(reduxForm(formProps)(LoginForm))
